import { apiClientWithMiddleware } from './utils/API';
import { captureException } from './utils/sentryAPI';
const ENDPOINT_EXPOSURE_BULK_LOG = `/treatments/v3/exposure/log`;
export const postExposure = (keys, mainIdentifier, identifiers) => {
  return apiClientWithMiddleware().post(ENDPOINT_EXPOSURE_BULK_LOG, {
    data: {
      exposures: keys.map(key => ({
        key,
        identifier: mainIdentifier
      })),
      identifiers
    }
  }).catch(err => {
    captureException(err);
  });
};
export const getExperimentVariant = (key, experiments) => {
  if (!experiments) {
    return 'control';
  }
  const experiment = experiments && experiments[key];
  return experiment && experiment.parameters.variants || 'control';
};
export const getExperimentGroup = (key, experiments) => {
  if (!experiments) {
    return 'control';
  }
  const experiment = experiments && experiments[key];
  return experiment && experiment.parameters.group || 'control';
};